import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { filtersToQueryString, initialFilters } from 'helpers/filtering';

import { getAllCustomers, updateCustomer } from 'api/customers';

import Table from 'components/table/table';
import { CUSTOMER_COLUMNS } from 'config/customer';
import { sanitize } from 'helpers/customer';

const Customers = () => {
  const [fetching, setFetching] = useState(true);
  const [allCustomers, setAllCustomers] = useState(null);
  const [meta, setMeta] = useState({});

  const fetchData = async (page, filters = {}, search) => {
    const filtersString = filtersToQueryString(filters, search);
    const data = await getAllCustomers(page, filtersString);

    setAllCustomers(data.items);
    setMeta(data.meta);
    setFetching(false);
  };

  useEffect(() => {
    (async () => {
      const initFilters = initialFilters(CUSTOMER_COLUMNS);
      await fetchData(1, initFilters);

      setFetching(false);
    })();
  }, []);

  const onUpdate = async (id, value) => {
    const customerId = allCustomers.findIndex((t) => t.id === id);
    allCustomers[customerId].location = value;

    await updateCustomer(id, sanitize(allCustomers[customerId]));
    setAllCustomers([...allCustomers]);
  };

  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header post-header">
          <h2 className="th-canvas-title" data-test-screen-title>
            <Link to="/customers" className="active">
              Customers
            </Link>
          </h2>
        </header>
        <section className="view-container">
          <Table
            columns={CUSTOMER_COLUMNS}
            data={allCustomers}
            meta={meta}
            hasViewBar
            fetching={fetching}
            fetchData={(p, f, s) => fetchData(p, f, s)}
            onSelect={(_, value, row) => onUpdate(row.id, value)}
          />
        </section>
      </section>
    </main>
  );
};

export default Customers;
